

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import logo from "../Assets/Image/gsda_logo.jpg";
import * as Action from "../actions/authActions";
import * as ActionAdmin from "../actions/adminAction";
import { InputAdornment, Stack, Button, CircularProgress, IconButton, Snackbar, TextField, Typography ,Alert} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const inputSx = {
  width: "100%",
  margin: "16px 0 !important",
  backgroundColor: "white",
  borderRadius: "10px !important",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "white",
  },
  "& input": {
    pointerEvents: "auto",
  },
};

const buttonSx = {
  backgroundColor: "#FFD401 !important",
  color: "#000 !important",
  fontWeight: "bold !important",
  height: "40px",
  width: "40%",
  borderRadius: "10px !important",
  marginTop: "0.5rem !important",
  border: "1px solid black !important",
  "&:hover": {
    backgroundColor: "#e6bf00 !important",
  },
};

const Login = ({
  userDetails,
  adminDetails,
  login,
  sendOtp,
  verifyOtp,
  getmaintenancedata,
  setActiveList,
}) => {
  const navigate = useNavigate();
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loginWithEmail, setLoginWithEmail] = useState(false);
  const [sendOtpForSignUp, setSendOtpForSignUp] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(true);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);
  const [otpSuccess, setOtpSuccess] = React.useState(false);
  const [otpFailure, setOtpFailure] = React.useState(false);
  const [otpVSuccess, setOtpVSuccess] = React.useState(false);
  const [InvaliidNumber, setInvaliidNumber] = React.useState(false);
  const [InvalidPassword, setInvalidPassword] = React.useState(false);
  const [NullPassword, setNullPassword] = React.useState(false);
  const [spinner, setSpinner] = React.useState(false);

  useEffect(() => {
    if (userDetails && userDetails?.userType[0] === "admin") {
      navigate("/admin/dashboard");
      setActiveList("/admin/dashboard");
    } else if (userDetails && userDetails?.userType[0] === "dc") {
      navigate("/district-coordinator/rollout-plan");
      setActiveList("/district-coordinator/rollout-plan");
    } else if (userDetails && userDetails?.userType[0] === "qc") {
      navigate("/QualityChecker/view-assign-district");
      setActiveList("/QualityChecker/view-assign-district");
    } else if (userDetails && userDetails?.userType[0] === "trainer") {
      navigate("/trainerLayout/rolloutPlan");
      setActiveList("/trainerlayout/rolloutplan");
    } else if (userDetails && userDetails?.userType[0] === "regional_coordinator") {
      navigate("/regional-coordinator/rolloutPlan");
      setActiveList("/regional-coordinator/rolloutPlan");
    } else if (userDetails && userDetails?.userType[0] === "client") {
      navigate("/clientLogin/rolloutPlan");
      setActiveList("/clientLogin/rolloutPlan");
    } else {
      navigate("/");
    }
  }, [userDetails]);

  // const handleClick = async (e) => {
  //   e.preventDefault();
  //   setSpinner(true);
  //   if (contact.length === 10 && password.length > 2 && !loginWithEmail) {
  //     const result = await login({ contact: contact, password: password });
  //     if (result && result.errors) {
  //       setError(result.errors);
  //       setSpinner(false);
  //       if (result.errors === "No user found") {
  //         setOtpFailure(true);
  //       } else if (result.errors === "Password incorrect") {
  //         setInvalidPassword(true);
  //       }
  //     } else {
  //       setSuccess(true);
  //       setSpinner(false);
  //       if (result && result?.user.user.userType[0] === "admin") {
  //         navigate("/admin/dashboard");
  //       } else if (result && result?.user.user.userType[0] === "dc") {
  //         navigate("/district-coordinator/rollout-plan");
  //       } else if (result && result?.user.user.userType[0] === "qc") {
  //         navigate("/QualityChecker/view-assign-district");
  //       } else if (result && result?.user.user.userType[0] === "trainer") {
  //         navigate("/trainerLayout/rolloutPlan");
  //       } else if (result && result?.user.user.userType[0] === "client") {
  //         navigate("/clientLogin/rolloutPlan");
  //       } else {
  //         navigate("/");
  //       }
  //     }
  //   } else if (contact.length === 10 && loginWithEmail) {
  //     setSendOtpForSignUp(true);
  //     const result = await sendOtp(contact);
  //     if (result.message === "no not register") {
  //       setOtpFailure(true);
  //       setSpinner(false);
  //     } else if (result && result.errors) {
  //       setError(result.errors);
  //     } else {
  //       setOtpSuccess(true);
  //       setSpinner(false);
  //     }
  //   } else {
  //     setSpinner(false);
  //     if (contact.length !== 10) {
  //       setInvaliidNumber(true);
  //     } else {
  //       if (password.length === 0) {
  //         setNullPassword(true);
  //       } else {
  //         setInvalidPassword(true);
  //       }
  //     }
  //   }
  // };
  const handleClick = async (e) => {
  e.preventDefault();

  // Reset all error states
  setError("");
  setInvaliidNumber(false);
  setInvalidPassword(false);
  setNullPassword(false);
  setOtpFailure(false);
  setOpen(false);

  // ---- Validation ----
  if (contact.length !== 10) {
    setInvaliidNumber(true);
    return;
  }

  if (!loginWithEmail && password.length <= 2) {
    if (password.length === 0) {
      setNullPassword(true);
    } else {
      setInvalidPassword(true);
    }
    return;
  }

  setSpinner(true);

  try {
    // ================= OTP LOGIN FLOW =================
    if (loginWithEmail) {
      setSendOtpForSignUp(true);
      const result = await sendOtp(contact);

      if (result?.message === "no not register") {
        setOtpFailure(true);
        setSpinner(false);
        return;
      }

      if (result?.errors) {
        setError(result.errors);
        setSpinner(false);
        return;
      }

      setOtpSuccess(true);
      setSpinner(false);
      return;
    }

    // ================= PASSWORD LOGIN FLOW =================
    const result = await login({ contact, password });

    // ❌ CASE 1: Wrong password / No user found
    if (result?.errors) {
      setSpinner(false);
      setError(result.errors);

      if (result.errors === "No user found") {
        setOtpFailure(true);
      } else if (result.errors === "Password incorrect") {
        setInvalidPassword(true);
      } else {
        setOpen(true);
      }
      return; // 🛑 Ruko yahin, navigate mat karo
    }

    // ✅ CASE 2: Successful Login
    if (result?.user?.user) {
      setSpinner(false);
      setSuccess(true);

      const userType = result.user.user.userType[0];

      if (userType === "admin") {
        navigate("/admin/dashboard");
        setActiveList("/admin/dashboard");
      } else if (userType === "dc") {
        navigate("/district-coordinator/rollout-plan");
        setActiveList("/district-coordinator/rollout-plan");
      } else if (userType === "qc") {
        navigate("/QualityChecker/view-assign-district");
        setActiveList("/QualityChecker/view-assign-district");
      } else if (userType === "trainer") {
        navigate("/trainerLayout/rolloutPlan");
        setActiveList("/trainerlayout/rolloutplan");
      } else if (userType === "regional_coordinator") {
        navigate("/regional-coordinator/rolloutPlan");
        setActiveList("/regional-coordinator/rolloutPlan");
      } else if (userType === "client") {
        navigate("/clientLogin/rolloutPlan");
        setActiveList("/clientLogin/rolloutPlan");
      } else {
        navigate("/");
      }
      return;
    }

    // ⚠️ CASE 3: Unexpected response
    setSpinner(false);
    setOpen(true);

  } catch (err) {
    // ⚠️ CASE 4: Network / thrown error
    console.error("Login Error:", err);
    setSpinner(false);
    setError(err?.message || "Something went wrong");
    setOpen(true);
  }
};
 

  const verifyOtoForSignUp = async (e) => {
    e.preventDefault();
    setSpinner(true);
    if (contact.length === 10 && otp.length === 4) {
      const result = await verifyOtp({
        contactNo: contact,
        newLoginOtp: otp,
      });
      if (result && result.errors) {
        setOtpVSuccess(true);
        setError(result.message);
      } else {
        setOtpVSuccess(true);
        setSpinner(false);
        setError(result.message);
      }
    } else {
      setSpinner(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOtpSuccess(false);
    setSuccess(false);
    setOtpVSuccess(false);
    setOtpFailure(false);
    setSendOtpForSignUp(false);
    setInvaliidNumber(false);
    setInvalidPassword(false);
    setNullPassword(false);
  };

  // const Alert = React.forwardRef(function Alert(props, ref) {
  //   // return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  // });

  return (
    <div
      className="login-page"
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#69a6e2",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        zIndex: 2147483647,
        pointerEvents: "auto",
      }}
    >
      <Stack sx={{ display: "flex", flexDirection: "row" }}>
        <Stack
          sx={{ display: { xs: "none", sm: "block" } }}
          style={{ flex: 1, flexDirection: "column" }}
        ></Stack>
        <div
          style={{
            flexDirection: "column",
            justifyContent: "space-between",
            maxWidth: 400,
            flex: 1,
          }}
        >

          <form className="login-form" onSubmit={(e) => e.preventDefault()}>
            <div className="login-logo-wrap">
              <div className="login-logo-inner" onClick={() => navigate("/")}>
                <img alt="GSDA Logo" src={logo} />
                <h2>SAMPADA PROJECT</h2>
              </div>
            </div>

            {loginWithEmail ? (
              <div className="login-fields">
                <div className="login-field">
                  <label htmlFor="login-contact">Mobile No.</label>
                  <div className="login-input-wrap">
                    <input
                      id="login-contact"
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="Mobile No."
                      className={`login-input ${contact.length <= 10 && contact.length !== 0
                        ? "login-input-error"
                        : ""
                        }`}
                      value={contact}
                      onChange={(e) =>
                        setContact(e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                  </div>
                  <div className="login-helper">
                    {contact.length <= 9 || contact.match(/[^0-9]/g)
                      ? "Please enter valid mobile No."
                      : ""}
                  </div>
                </div>

                {sendOtpForSignUp && otpFailure === false ? (
                  <div className="login-field">
                    <label htmlFor="login-otp">One Time Password</label>
                    <div className="login-input-wrap">
                      <input
                        id="login-otp"
                        type={showPassword ? "password" : "text"}
                        name="otp"
                        autoComplete="off"
                        maxLength={4}
                        inputMode="numeric"
                        placeholder="One Time Password"
                        className={`login-input login-input-password ${otp.length <= 4 ? "login-input-error" : ""
                          }`}
                        value={otp}
                        onChange={(e) =>
                          setOtp(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                      <button
                        type="button"
                        className="login-eye-btn"
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label={showPassword ? "Show OTP" : "Hide OTP"}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </button>
                    </div>
                    <div className="login-helper">
                      {otp.length <= 3 || contact.match(/[^0-9]/g)
                        ? "Please enter valid One Time Password"
                        : ""}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {!loginWithEmail ? (
              <div className="login-fields">
                <div className="login-field">
                  <label htmlFor="login-mobile">Mobile no.</label>
                  <div className="login-input-wrap">
                    <input
                      id="login-mobile"
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="Mobile no."
                      className={`login-input ${contact.length !== 10 && contact.length !== 0
                        ? "login-input-error"
                        : ""
                        }`}
                      value={contact}
                      onChange={(e) =>
                        setContact(e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                  </div>
                  <div className="login-helper">
                    {(contact.length !== 10 && contact.length !== 0) ||
                      contact.match(/[^0-9]/g)
                      ? "Please enter valid mobile No."
                      : ""}
                  </div>
                </div>

                <div className="login-field">
                  <label htmlFor="login-password">Password</label>
                  <div className="login-input-wrap">
                    <input
                      id="login-password"
                      type={showPassword ? "password" : "text"}
                      name="password"
                      autoComplete="on"
                      placeholder="Password"
                      className={`login-input login-input-password ${password.length <= 2 && password.length !== 0
                        ? "login-input-error"
                        : ""
                        }`}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="login-eye-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={showPassword ? "Show password" : "Hide password"}
                    >
                      {showPassword ? (
                        <VisibilityOff fontSize="small" />
                      ) : (
                        <Visibility fontSize="small" />
                      )}
                    </button>
                  </div>
                  <div className="login-helper">
                    {password.length <= 2 && password.length !== 0
                      ? "Password should be greater than 2 character"
                      : ""}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="login-actions">
              {loginWithEmail && !sendOtpForSignUp ? (
                <button
                  type="button"
                  className="login-btn"
                  onClick={handleClick}
                  disabled={spinner}
                >
                  {spinner ? <span className="login-spinner" /> : "Send OTP"}
                </button>
              ) : null}

              {!loginWithEmail ? (
                <button
                  type="button"
                  className="login-btn"
                  onClick={handleClick}
                  disabled={spinner}
                >
                  {spinner ? <span className="login-spinner" /> : "Login"}
                </button>
              ) : null}

              {loginWithEmail && sendOtpForSignUp ? (
                <button
                  type="button"
                  className="login-btn"
                  onClick={verifyOtoForSignUp}
                  disabled={spinner}
                >
                  {spinner ? <span className="login-spinner" /> : "Verify OTP"}
                </button>
              ) : null}

              {loginWithEmail && sendOtpForSignUp && (
                <button
                  type="button"
                  className="login-btn"
                  onClick={() => {
                    setSendOtpForSignUp(false);
                    setLoginWithEmail(false);
                  }}
                >
                  Back
                </button>
              )}
            </div>
          </form>

          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
              Invalid Credentials !
            </Alert>
          </Snackbar>
          <Snackbar
            open={InvaliidNumber}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
              Enter Valid Mobile Number !
            </Alert>
          </Snackbar>
          <Snackbar
            open={InvalidPassword}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
              Invalid Password !
            </Alert>
          </Snackbar>
          <Snackbar
            open={NullPassword}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
              Please Enter Valid Password !
            </Alert>
          </Snackbar>
          <Snackbar
            open={success}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              Login successfully.
            </Alert>
          </Snackbar>
          <Snackbar
            open={otpSuccess}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              OTP will send to register mobile number
            </Alert>
          </Snackbar>
          <Snackbar
            open={otpFailure}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
              Your Number is not Registered. Kindly please contact to the
              support team.
            </Alert>
          </Snackbar>
          <Snackbar
            open={otpVSuccess}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={error && error.startsWith("Not") ? "error" : "success"}
              sx={{ width: "100%" }}
            >
              {error && error.startsWith("Not")
                ? error
                : "Sign up successfully."}
            </Alert>
          </Snackbar>
        </div>
        <Stack
          sx={{ display: { xs: "none", sm: "block" } }}
          style={{ flex: 1, flexDirection: "column" }}
        ></Stack>
      </Stack>
      <div style={{ marginTop: 20 }}>
        <Typography
          variant="body2"
          component="div"
          style={{
            color: "white",
            position: "relative",
            left: 0,
            right: 0,
            bottom: 0,
            textAlign: "center",
            marginTop: 8,
            marginBottom: 8,
          }}
        >
          Powered By{" "}
          <a
            style={{ color: "white" }}
            href="https://www.foxberry.in/"
            target="_blank"
            rel="noreferrer"
          >
            Foxberry Technologies
          </a>{" "}
          &copy; {new Date().getFullYear()}
        </Typography>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.auth.userDetails,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    login: (data) => dispatch(Action.login(data)),
    sendOtp: (data) => dispatch(Action.sendOtp(data)),
    verifyOtp: (data) => dispatch(Action.verifyOtp(data)),
    setActiveList: (data) => dispatch(ActionAdmin.setActiveList(data)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Login);